export const SearchInternshipRefinement = {
  AREAS_OF_FOCUS: 'areasOfFocus',
  FUNCTIONS: 'functions',
  LOCALE: 'locale',
  LOCATION_TYPE: 'locationType',
  ORG_TYPE: 'orgType',
  PAYMENT: 'payment',
  RADIUS: 'radius',
  RECENCY: 'recency',
} as const;

export const SEARCH_INTERNSHIP_REFINEMENT_NAMES = Object.values(
  SearchInternshipRefinement,
);

export const SEARCH_INTERNSHIP_REFINEMENT_LABELS = Object.defineProperties(
  {},
  {
    [SearchInternshipRefinement.AREAS_OF_FOCUS]: {
      get: () => getText('Cause Areas'),
      enumerable: true,
    },
    [SearchInternshipRefinement.FUNCTIONS]: {
      get: () => getText('Internship Function'),
      enumerable: true,
    },
    [SearchInternshipRefinement.LOCALE]: {
      get: () => getText('Listing Language'),
      enumerable: true,
    },
    [SearchInternshipRefinement.LOCATION_TYPE]: {
      get: () => getText('Location Type'),
      enumerable: true,
    },
    [SearchInternshipRefinement.ORG_TYPE]: {
      get: () => getText('Org Type'),
      enumerable: true,
    },
    [SearchInternshipRefinement.PAYMENT]: {
      get: () => getText('Payment'),
      enumerable: true,
    },
    [SearchInternshipRefinement.RADIUS]: {
      get: () => getText('Radius'),
      enumerable: true,
    },
    [SearchInternshipRefinement.RECENCY]: {
      get: () => getText('Recency'),
      enumerable: true,
    },
  },
) as Record<SearchInternshipRefinementType, string>;

export type SearchInternshipRefinementType =
  (typeof SearchInternshipRefinement)[keyof typeof SearchInternshipRefinement];
